export default __webpack_public_path__ + "src/assets/membership-none.86b11bcca66ee0db88300e89dcff0f36.svg";